import { render, staticRenderFns } from "./SaveSupplier.vue?vue&type=template&id=0a7e70ee&scoped=true&"
import script from "./SaveSupplier.vue?vue&type=script&lang=js&"
export * from "./SaveSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7e70ee",
  null
  
)

export default component.exports